import React from 'react';
import { Paper, Typography, Container, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
const GestionsCookies = () => {
    const theme = useTheme();
    const handleClick = (event) => {
        event.preventDefault(); // Prevent default anchor behavior
        window.openAxeptioCookies(); // Call the JavaScript function
    };
    return (
        <Container maxWidth="lg" style={{ marginTop: '20px', marginBottom: '40px' }}>
            <Paper elevation={3} style={{ padding: '20px',
                Color: theme.palette.mode === 'dark' ? theme.palette.dark.main : theme.palette.primary.light
            }}>
                <Typography paragraph>
                    Les cookies sont de petits fichiers textes déposés par votre explorateur sur votre ordinateur lors de la visite d’un site ou de la consultation d’une publicité. Ils ont notamment pour but de collecter des informations relatives à votre navigation sur les sites et de vous adresser des services personnalisés.
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Les cookies selon la CNIL.
                </Typography>
                <Typography paragraph>
                    Le site MonUnip utilise les cookies suivants :
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Cookies de session
                </Typography>
                <Typography paragraph>
                    Il s’agit des cookies nécessaires à l’identification de l’utilisateur pour accéder à un service en ligne nécessitant une authentification. Les informations de session ainsi obtenues par les cookies sont enregistrées sur l’équipement terminal de l’utilisateur et sur le serveur qui héberge le site, situé en Irlande chez AWS. Ces cookies sont conservés 3 ans à compter de la première connexion en ligne nécessitant une authentification.
                </Typography>
                <Typography variant="h6" gutterBottom>
                    Cookies d’audience
                </Typography>
                <Typography paragraph>
                    Ces cookies permettent de comptabiliser les utilisateurs et d’identifier la manière dont ils utilisent le site. Ils sont déposés et lus sur l’équipement terminal de l’utilisateur et dès que ce dernier accède à un site web utilisant le service « Google Analytics ». Les données ainsi collectées sont transmises et stockées par la société Google Inc aux Etats-Unis.
                </Typography>
                <Typography paragraph>
                    Les données générées par ces cookies concernent l’utilisation du site (durée des visites, pages consultées, localisation, système d’exploitation, navigateur, voie d’accès, nombre de visites) et l’adresse IP de l’utilisateur afin de déterminer la ville de connexion. La durée de vie de ces cookies est de 14 mois à compter de la dernière activité de l’utilisateur.
                </Typography>
                <Typography paragraph>
                    Pour plus d’informations sur le service Google Analytics, vous pouvez consulter : <a href="https://support.google.com/analytics/answer/6004245?hl=fr" target={"_blank"}>Google Analytics – Protection de vos données.</a>
                </Typography>
                <Typography paragraph>
                    Découvrez également comment <a href="https://tools.google.com/dlpage/gaoptout/?hl=fr" target={"_blank"}>désactiver Google Analytics sur votre navigateur</a>.
                </Typography>
                <Typography paragraph>
                <strong>Modifiez ses choix à tout moment</strong>
                </Typography>
                <Typography paragraph>
                    Un module est disponible pour sélectionner les cookies que vous souhaitez accepter et ceux que vous préférez refuser sur notre site. À tout moment, en <a href="#" onClick={handleClick}> cliquant ici </a>, et accessible depuis toutes les pages de notre site, vous pourrez accéder au module et modifier vos préférences.
                </Typography>
            </Paper>
        </Container>
    );
};

export default GestionsCookies;
